import { useState } from "react";
import { Grid, TextField, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Api } from "queries/types";

const extractNumber = (string: string) => Number.parseInt(string.replaceAll(/[^0-9]/g, ""));

interface GridSizeFormProps {
  shopGrid: Api.ShopGrid | null;
  onSubmit: ({ height, width }: { height: number; width: number }) => void;
}

const GridSizeForm = ({ shopGrid, onSubmit }: GridSizeFormProps) => {
  const { t } = useTranslation();
  const [size, setSize] = useState({ height: shopGrid?.height, width: shopGrid?.width });
  const [submitted, setSubmitted] = useState(Boolean(shopGrid));

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (shopGrid && !window.confirm(t("shop.edit.changeSizeConfirmation"))) {
          setSubmitted(true);
          return;
        }

        onSubmit({ height: size.height!, width: size.width! });
        setSubmitted(true);
      }}
    >
      <Grid container spacing={1}>
        <Grid item sm={2} xs={4}>
          <TextField
            value={size.height || ""}
            onChange={(e) => setSize({ ...size, height: extractNumber(e.target.value) })}
            label={t("height")}
            variant="standard"
            disabled={submitted}
          />
        </Grid>
        <Grid item sm={2} xs={4}>
          <TextField
            value={size.width || ""}
            onChange={(e) => setSize({ ...size, width: extractNumber(e.target.value) })}
            label={t("width")}
            variant="standard"
            disabled={submitted}
          />
        </Grid>
        <Grid item sm={2} xs={4}>
          {submitted ? (
            <Button key="edit" sx={{ mt: 2 }} onClick={() => setSubmitted(false)}>
              {t("edit")}
            </Button>
          ) : (
            <Button
              key="validate"
              type="submit"
              variant="contained"
              sx={{ mt: 2 }}
              disabled={!size.height || !size.width}
            >
              {t("validate")}
            </Button>
          )}
        </Grid>
      </Grid>
    </form>
  );
};

export default GridSizeForm;
